import { writable } from 'svelte/store';
import { podcastInstance, podcastPath } from './conteudo';

const navegacaoStore = writable({
  sidebarAberta: false,
  paginas: [''],
  modulo: 1,
  titulo: '',
  paginaAtual: 1,
  podcastPath: 'assets/podcasts/podcast_m1_',
  podcastInstance: 0,
  imagePath: 'assets/images/modulo/imagem_',
  imageInstance: 0,
  recurso: 0,
  textos: [''][''],
  pageAlreadyLoaded: false,
  videos: ['']
});

export default navegacaoStore;
